import { computed } from 'vue'
import { useDiscountAssociationParameters } from '@invivodf/common/src/contexts/discount'
import { useParametersFormatter, useTransversalParameters } from '@invivodf/common/src/contexts/parameters'

export const useParameters = () => {
  const transversalParameters = useTransversalParameters()
  const discountAssociationParameters = useDiscountAssociationParameters()

  const sections = computed(() => {
    return useParametersFormatter([...transversalParameters, ...discountAssociationParameters])
  })

  return { sections }
}
